module.exports = __webpack_public_path__ + "static/media/google_meet_recording_reminder.013e91b9.png";